// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0d838e69","703":"cc896c0f"}[chunkId] + ".chunk.js";
};